import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacySelect as MatSelect } from '@angular/material/legacy-select';
import { Router } from '@angular/router';
import { thru } from 'lodash';
import { InstanceService } from 'src/app/core/services/instance-management/instance.service';
import { DialogService } from 'src/app/shared/dialog/confirm-dialog/dialog.service';
import { InstanceManagement } from 'src/app/shared/enum/instance-management';
import { NotificationService } from 'src/app/shared/notification/notification.service';

@Component({
  selector: 'app-request-application-logs',
  templateUrl: './request-application-logs.component.html',
  styleUrls: ['./request-application-logs.component.scss']
})
export class RequestApplicationLogsComponent implements OnInit{
  @ViewChild('levelData') levelData!: MatSelect;
  breadCrumbItems: any = [];
  ViewData : any = [];
  instanceId: any = 0;
  public instanceEnum = InstanceManagement;
  startDateError: boolean = false;
  startDateErrorMsg: string = "";
  endDateError: boolean = false;
  endDateErrorMsg: string = "";
  traceIdError: boolean = false;
  getStartValueappLog: any;
  getEndValueappLog : any;
  validateConfirmAction: boolean = true;
  minAppStartDate: any;
  maxAppStartDate: any;
  startDate = new Date();
  endDate = new Date();
  getdate = new Date();
  OnInitendDate = new Date();
  maxAppEndDate: any;
  setApplicationMinEndDate = new Date();
  //selectedLogType: any;
  showLevelType: boolean = false;
  getSearchValueappLog: string = "";
  getTraceId: string = "";
  getContextUserId: string = "";
  getContextInstanceEntityName: string = "";
  getContextInstanceId: string = "";
  levelList:any = ['All','Information','Error','Warning','Fatal','Verbose'];

  constructor(
    private instanceService: InstanceService,
    private datePipe: DatePipe,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private router: Router,
  ){
    
  }
  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Home', path: 'resources' },
      { label: 'Instance Operations', path: 'instanceoperations/instance-requests' },
      { label: 'Instances', path: 'instanceoperations/instance-requests' },
      { label: 'Instance Tools', path: 'instance-tools' },
    ];
    this.instanceId = localStorage.getItem('instanceID');
    this.getInstanceByID();
    this.getdate.setHours(this.getdate.getHours() - 1);
    this.startDate.setDate(this.startDate.getDate() - 30);
    this.minAppStartDate = this.startDate.toISOString().substring(0,16);
    this.maxAppStartDate = this.endDate.toISOString().substring(0,16);
    this.maxAppEndDate = this.transformDate(this.endDate);
    this.setApplicationMinEndDate = this.minAppStartDate;
    this.getStartValueappLog = this.getdate.toISOString().substring(0, 16);   
    this.getEndValueappLog = this.OnInitendDate.toISOString().substring(0, 16);
    
  }

  //datetime Validation
  transformDate(selectedDate: any) {
    return this.datePipe.transform((selectedDate.toISOString()), 'YYYY-MM-ddThh:mm','UTC');

  }
  getInstanceByID() {
    try {
      this.instanceService
        .getInstanceByID(this.instanceId)
        .subscribe((resp: any) => {
          let result = resp.body;
          if (result != undefined && result != null) {
            this.ViewData = result;         
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  validateApplicationLogDates(elem: any) {
    this.startDateError = false;
    this.startDateErrorMsg = "";
    this.endDateError = false;
    this.endDateErrorMsg = "";

    if (elem.value == "") {
      this.validateConfirmAction = true;
      return;
    }

    var startDate = this.getStartValueappLog;
    var endDate = this.getEndValueappLog;

    let minDate = new Date();
    minDate.setDate(minDate.getDate() - 1);
    let minStartDate = minDate.toISOString().substring(0, 16);
    let minEndDate = minDate.toISOString().substring(0, 16);

    let maxStartDate = new Date().toISOString().substring(0, 16);
    let maxEndDate = new Date().toISOString().substring(0, 16);


    if (elem.id == "appStartDate" && elem.value != "") {
      if (isNaN(new Date(startDate).getTime())) {
        this.startDateError = true;
        this.startDateErrorMsg = this.instanceEnum.instance_error_InvalidStartDate;
        this.validateConfirmAction = true;
        return;
      }

      if (new Date(startDate).getTime() > new Date(maxStartDate).getTime()) {
        this.startDateError = true;
        this.startDateErrorMsg = this.instanceEnum.instance_error_startdate_less + " " + new Date(maxStartDate).toLocaleString('en-US', { hour12: true }) + " (UTC).";
        this.validateConfirmAction = true;
        return;
      }

      if(this.getStartValueappLog < this.minAppStartDate || this.getStartValueappLog > this.maxAppStartDate ){
        this.startDateError = true;
        this.startDateErrorMsg= this.instanceEnum.instance_date_error_msg +this.datePipe.transform(this.minAppStartDate,'short')+ ' and ' +this.datePipe.transform(this.maxAppStartDate,'short') + ' (UTC).';
        this.validateConfirmAction = true;
        return;
      }
    }

    if (elem.id == "appEndDate" && elem.value != "") {
      if (isNaN(new Date(endDate).getTime())) {
        this.endDateError = true;
        this.endDateErrorMsg = this.instanceEnum.instance_error_InvalidEndDate;
        this.validateConfirmAction = true;
        return;
      }

      if (new Date(endDate).getTime() <= new Date(startDate).getTime()) {
        this.endDateError = true;
        this.endDateErrorMsg = this.instanceEnum.instance_error_enddate;
        this.validateConfirmAction = true;
        return;
      }
      var daysBetweenDates = this.gethrsDifference(startDate, endDate);

      if (daysBetweenDates > 1) {
        this.endDateError = true;
        this.endDateErrorMsg = this.instanceEnum.instance_error_enddate_range;
        this.validateConfirmAction = true;
        return;
      }
    }

    if (this.getStartValueappLog != "" && this.getEndValueappLog != "") {
      if (this.startDateError == false && this.endDateError == false) {
        this.validateConfirmAction = false;
      }
    }
    else { this.validateConfirmAction = true; }

  }

  gethrsDifference(startDate: any, endDate: any) {
    let timeInMilisec: number = new Date(endDate).getTime() - new Date(startDate).getTime();
    let hrsBetweenDates: number = timeInMilisec / (1000 * 60 * 60);
    return hrsBetweenDates;
  }

  applicationStartDateValueChange(event: any) {
    this.setApplicationMinEndDate = this.getStartValueappLog;
    this.getEndValueappLog = '';
  }

  // logTypeChange(event:any) {
  //   this.selectedLogType = event?.value;
  //   if (this.selectedLogType == 0)
  //   {
  //     this.validateConfirmAction = false;
  //   }
  //   else {
  //     this.validateConfirmAction = true;
  //   }
  // }

  levelChange(event:any) {
    if (event?.value != null)
        {
          this.validateConfirmAction = false;
        }
        else {
          this.validateConfirmAction = true;
        }
  }

  validateConfirm(inputData: any) {
    if (inputData?.value != "") { 
      this.validateConfirmAction = false;
      this.traceIdError = false;
    }
    else {
      this.validateConfirmAction = true;    
      this.traceIdError = true;
    }     
  }
  onConfirm(){
    this.applicationLog();
  }

  onCancel(){
    this.router.navigate(['home/instanceoperations/instance-requests/instance-tools-landing']);
  }

  applicationLog() {
    this.dialogService.confirmDialog({
      title: this.instanceEnum.instance_view_application_log_requested,
      module: 'Application_Log',
      message: this.instanceEnum.instance_view_application_log_popuptext +'<b> Confirm. </b>'+ this.instanceEnum.instance_view_application_log_popuptext1,
      confirmText: 'Confirm',
      cancelText: 'Cancel'
    }).subscribe((res: any) => {
      if (res) {
        let paramreqdata = {
          "PageIndex": 1,
          "PageSize": 50,
          "startDateTime": this.getStartValueappLog,
          "endDateTime": this.getEndValueappLog,
          "filterParameters": [
            {
              "field": "SearchString",
              "value": this.getSearchValueappLog,
            },
            {
              "field": "TraceId",
              "value": this.getTraceId,
            },
            {
              "field": "Level",
              "value":  this.levelData?.value == 'All' ? '' : this.levelData?.value,
            },
            {
              "field": "ContextUserId",
              "value": this.getContextUserId,
            },
            {
              "field": "ContextInstanceEntityName",
              "value": this.getContextInstanceEntityName,
            },
            {
              "field": "ContextInstanceId",
              "value": this.getContextInstanceId
            },
            {
              "field": "LogType",
              "value": "0"
            }
          ],

        };
        this.instanceService.downloadApplicationLog(this.instanceId, paramreqdata).
          subscribe((data) => {
            this.navigateToHistory();
          },(error =>{
            this.notificationService.showNotification(error,'warning',this.instanceEnum.instance_view_application_log_header)
          })
        );
      }
    })
  }

  navigateToHistory(){
    let json={
      path:"toolsPage",
      id:'',
      name:''
    }
    this.instanceService.sendData(JSON.stringify(json));
    this.router.navigate(['home/instanceoperations/instance-requests/history']);
  }
}
